import { Navigate } from "react-router-dom";
import { NotAuthorized } from "./NotAutorized";

type GuardProps = {
  isAuthenticated: boolean;
  hasAccess: boolean;
  children: React.ReactNode;
};

export const AuthRoleGuard = ({
  isAuthenticated,
  hasAccess,
  children,
}: GuardProps) => {
  // 1. Not authenticated → go login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

 
  if (!hasAccess) {
    return <NotAuthorized />;
  }

  
  return <>{children}</>;
};